<div class="modal" [class.show]="isOpen" [style.display]="isOpen ? 'block' : 'none'" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">
                    {{ existingPaymentInfo ? ('seller_profile.edit_payment' | translate) : ('seller_profile.add_payment' | translate) }}
                </h5>
                <button type="button" class="btn-close" (click)="onClose()"></button>
            </div>
            <div class="modal-body">
                <form [formGroup]="paymentForm" (ngSubmit)="onSubmit()">
                    <!-- Payment Method Selection -->
                    <div class="mb-4">
                        <label class="d-block mb-2">{{'seller_setup.payment_method' | translate}} *</label>
                        <div class="btn-group w-100" role="group">
                            <input 
                                type="radio" 
                                class="btn-check" 
                                id="modalMobileMoney" 
                                formControlName="paymentType"
                                [value]="PAYMENT_TYPE_MOBILE_MONEY">
                            <label class="btn btn-outline-primary" for="modalMobileMoney">
                                <i class="fas fa-mobile-alt me-2"></i>{{'seller_setup.mobile_money' | translate}}
                            </label>
                            
                            <input 
                                type="radio" 
                                class="btn-check" 
                                id="modalBankTransfer" 
                                formControlName="paymentType"
                                [value]="PAYMENT_TYPE_BANK">
                            <label class="btn btn-outline-primary" for="modalBankTransfer">
                                <i class="fas fa-university me-2"></i>{{'seller_setup.bank_transfer' | translate}}
                            </label>
                        </div>
                        <div *ngIf="submitted && f.paymentType.errors" class="text-danger small mt-1">
                            {{'seller_setup.payment_method_required' | translate}}
                        </div>
                    </div>

                    <!-- Mobile Money Fields -->
                    <div *ngIf="f.paymentType.value === PAYMENT_TYPE_MOBILE_MONEY" class="mb-3">
                        <div class="mb-3">
                            <label for="modalMobileProvider">{{'seller_setup.mobile_money_provider' | translate}} *</label>
                            <select 
                                id="modalMobileProvider" 
                                class="form-select"
                                [ngClass]="{ 'is-invalid': submitted && f.mobileMoneyProvider.errors }"
                                formControlName="mobileMoneyProvider">
                                <option value="">{{'common.select' | translate}}</option>
                                <option [value]="MOBILE_PROVIDER_MTN">{{'seller_setup.mtn_momo' | translate}}</option>
                                <option [value]="MOBILE_PROVIDER_ORANGE">{{'seller_setup.orange_money' | translate}}</option>
                            </select>
                            <div *ngIf="submitted && f.mobileMoneyProvider.errors" class="invalid-feedback">
                                {{'seller_setup.mobile_money_provider_required' | translate}}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="modalMobileNumber">{{'seller_setup.mobile_money_number' | translate}} *</label>
                            <input 
                                type="text" 
                                id="modalMobileNumber" 
                                class="form-control"
                                [ngClass]="{ 'is-invalid': submitted && f.mobileMoneyNumber.errors }"
                                formControlName="mobileMoneyNumber"
                                placeholder="6XXXXXXXX">
                            <div *ngIf="submitted && f.mobileMoneyNumber.errors" class="invalid-feedback">
                                <div *ngIf="f.mobileMoneyNumber.errors.required">{{'seller_setup.mobile_money_number_required' | translate}}</div>
                                <div *ngIf="f.mobileMoneyNumber.errors.pattern">{{'seller_setup.invalid_mobile_number' | translate}}</div>
                            </div>
                        </div>
                    </div>

                    <!-- Bank Transfer Fields -->
                    <div *ngIf="f.paymentType.value === PAYMENT_TYPE_BANK" class="mb-3">
                        <div class="mb-3">
                            <label for="modalBankName">{{'seller_setup.bank_name' | translate}} *</label>
                            <input 
                                type="text" 
                                id="modalBankName" 
                                class="form-control"
                                [ngClass]="{ 'is-invalid': submitted && f.bankName.errors }"
                                formControlName="bankName">
                            <div *ngIf="submitted && f.bankName.errors" class="invalid-feedback">
                                {{'seller_setup.bank_name_required' | translate}}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="modalAccountNumber">{{'seller_setup.account_number' | translate}} *</label>
                            <input 
                                type="text" 
                                id="modalAccountNumber" 
                                class="form-control"
                                [ngClass]="{ 'is-invalid': submitted && f.accountNumber.errors }"
                                formControlName="accountNumber">
                            <div *ngIf="submitted && f.accountNumber.errors" class="invalid-feedback">
                                {{'seller_setup.account_number_required' | translate}}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="modalAccountHolder">{{'seller_setup.account_holder_name' | translate}} *</label>
                            <input 
                                type="text" 
                                id="modalAccountHolder" 
                                class="form-control"
                                [ngClass]="{ 'is-invalid': submitted && f.accountHolderName.errors }"
                                formControlName="accountHolderName">
                            <div *ngIf="submitted && f.accountHolderName.errors" class="invalid-feedback">
                                {{'seller_setup.account_holder_name_required' | translate}}
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer px-0 pb-0">
                        <button type="button" class="btn btn-secondary" (click)="onClose()">
                            {{'common.cancel' | translate}}
                        </button>
                        <button type="submit" class="btn btn-primary">
                            {{'common.save' | translate}}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<div class="modal-backdrop fade show" *ngIf="isOpen"></div>
